import React, { useState } from "react"
import { ConversationMessage } from "@store"
import { TouchableOpacity } from "react-native"
import { Text } from "@components"
import { Pin } from "./Pin"
import { useTheme } from "@react-navigation/native"
import getStyle from "./style"

export const RenderPinned = ({pinnedMessages, color, onPress} : {pinnedMessages: ConversationMessage[], color: string, onPress: (id: string) => void}) => {
    const theme = useTheme()
    const styles = getStyle(theme)
  
    const [pinnedIndex, setPinnedIndex] = useState(0)

    const changePinIndex = () => {
        setPinnedIndex(index => {
            const newIndex = (pinnedMessages.length === index + 1)? 0 : index + 1
            onPress(pinnedMessages[index].id)
            return newIndex
        })
    }
    
    return pinnedMessages.length > 0 ? (
        <TouchableOpacity onPress={changePinIndex} style={[styles.pinnedContainer, { backgroundColor: color }]}>
            <Pin />
            <Text type='bodySmall'>{pinnedMessages[pinnedIndex].text}</Text>
        </TouchableOpacity>
    ) : null
}